import { Component, OnInit, ViewChild,Input, Output } from '@angular/core';
import { HTTPClientService } from '../../shared/services/httpclient.service';
import { LanguageService } from '../../shared/services/language.service';

import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { NewsService } from '../../shared/services/news.service';
import { ProductsService } from '../../shared/services/products.service';
import { TranslateService } from '@ngx-translate/core';

declare var $:any;
import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;


@Component({
	selector: 'app-university',
	templateUrl: './university.component.html',
	styleUrls: ['./university.component.scss'],
})
export class UniversityComponent implements OnInit {
	public blocnews = null;
	public imagenews = null;
	public listProducts: any = [];
	public tagId = 246

	public images = [
		{
			url: 'assets/logos-sectors/bureau-veritas',
			alt: 'logo university bureau veritas',
			title: 'bureau veritas',
		},
		{
			url: 'assets/logos-sectors/imt-mines-albi',
			alt: 'logo university imt mines albi',
			title: 'imt mines albi',
		},
		{
			url: 'assets/logos-sectors/institute-of-technology-seal-of-the-georgia',
			alt: 'logo university institute of technology seal of the georgia',
			title: 'institute of technology seal of the georgia',
		},
		{
			url: 'assets/logos-sectors/itc-ilo',
			alt: 'logo university itc ilo',
			title: 'itc ilo',
		},
		{
			url: 'assets/logos-sectors/iut-lille',
			alt: 'logo university iut lille',
			title: 'iut lille',
		},
		{
			url: 'assets/logos-sectors/iut-occitanie',
			alt: 'logo university iut occitanie',
			title: 'iut occitanie',
		},
	];

	public slides2: any = [
		{
			name: this.translate.instant(
				'Raphaël Oger, Head of the communication division, IMT Mines Albi Alumni'
			),
			job: this.translate.instant(
				'« The participants were pleasantly surprised by our event on the virtual campus of Immersive Factory as they expected a one-direction event as often seen on standard platforms. Overall, from the participant point of view, the event exceeded all expectations. They [the participants] were definitely satisfied with the solution we found thanks to Immersive Factory. »'
			),
			logo: 'assets/logos-carousels/imt-mines-albi-alumni.png',
			logoName: 'IMT Mines Albi Alumni',
		},
	];

	public slides: any = [
		{ src: 'assets/produits/virtual-campus-hall.jpg', name: 'Hall' },
		{ src: 'assets/produits/virtual-campus-cinema.jpg', name: 'Cinema' },
		{ src: 'assets/produits/virtual-campus-conference.jpg', name: 'Conference room' },
		{ src: 'assets/produits/virtual-campus-offices.jpg', name: 'Offices' },
		{ src: 'assets/produits/virtual-campus-training-room.jpg', name: 'Training room' },
		{ src: 'assets/produits/virtual-campus-outdoor.jpg', name: 'Outdoor' },
	];

    workshops = []

	constructor(
		public accountService: AccountService,
		private productService: ProductsService,
		public newsService: NewsService,
		public language: LanguageService,
		public appService: AppService,
		public router: Router,
		public translate: TranslateService
	) {}

	ngOnInit(): void {
		this.newsService.getNews(128).then((results) => {
			this.blocnews = this.newsService.formateOneNews(results);
		});
        this.productService.searchProducts("",[this.tagId], 0, 12)
        .then((res)=>{
            if(res && res.datas && res.datas.length){
                this.workshops = this.productService.setProductsInfos(res.datas,-1,-1);
            }
        })

	}
}
